module.exports = (function ($) {
    // Set up the datepicker
    $('input[type=date]').addClass('input--datepicker').datepicker({
        format: 'yyyy-mm-dd'
    });
})(jQuery);



// WEBPACK FOOTER //
// ./resources/assets/js/components/datepicker.js